import { createElement } from 'react';
import { ak as OverlayWrapper$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var OverlayWrapper = function OverlayWrapper(props) {
  return /*#__PURE__*/createElement(OverlayWrapper$1, __assign({}, props));
};
OverlayWrapper.displayName = 'OverlayWrapper';

export { OverlayWrapper };
